import React from "react";
import { capitalise, humanFileSize } from "../../../utils";

export default function (props) {
    const { file } = props;

    const trackDownload = (url) => {
        if (window._paq) {
            window._paq.push(["trackLink", url, "download"]);
        }
    };

    const filenameFromUrl = (url) =>
        url.substring(url.lastIndexOf("/") + 1);

    let linktext;

    if (file.size) {
        linktext =
            filenameFromUrl(file.url) +
            (file.size ? ` (${humanFileSize(file.size)}) ` : " ");
    } else {
        if (file.meta.filetype) {
            linktext = `${file.meta.data_type} (${file.meta.filetype}) `;
        } else {
            linktext = `${file.meta.data_type} `;
        }
    }

    let source =
        file.meta.data_source ||
        (file.dataset ? file.dataset.location : null);

    return (
        <div className="dataset-list-item">
            <span className="dataset-type">
                {capitalise(file.meta.level)}{" "}
            </span>

            <a
                href={file.url}
                download
                onClick={() => trackDownload(file.url)}
            >
                {linktext}
            </a>

            {(file.dataset || file.meta.data_source) && (
                <span className="small">
                    {" "}
                    - Source: <i>{source}</i>
                </span>
            )}
        </div>
    );
}